type ModelData<T> = T extends null
  ? undefined
  : T extends readonly (infer Item)[]
    ? ModelData<Item>[]
    : T extends object
      ? { [Key in keyof T]: ModelData<T[Key]> }
      : T

// Cached model types use undefined for absent fields; operation types use GraphQL null.
export function modelData<T>(value: T, jsonFields: readonly (keyof NonNullable<T>)[] = []): ModelData<T> {
  if (value === null) return undefined as ModelData<T>
  if (Array.isArray(value)) return value.map((item) => modelData(item)) as ModelData<T>
  if (typeof value === 'object' && value !== null) {
    return Object.fromEntries(
      Object.entries(value).map(([key, item]) => [
        key,
        item !== null && jsonFields.some((field) => field === key) ? item : modelData(item),
      ]),
    ) as ModelData<T>
  }
  return value as ModelData<T>
}
